import React from "react";

export default function SectionTitle({ overline, title, align = "center", light = false }) {
  return (
    <div className={`mb-12 ${align === "center" ? "text-center" : ""}`}>
      {overline && (
        <div className="text-[#c5a76f] text-sm tracking-[0.25em] uppercase font-medium mb-3">
          {overline}
        </div>
      )}
      <h2
        className={`text-3xl md:text-5xl font-bold tracking-tight ${
          light ? "text-white" : "text-[#c5a76f]"
        }`}
        style={{ fontFamily: "'Familjen Grotesk', serif" }}
      >
        {title}
      </h2>
    </div>
  );
}
